import React, { ReactNode } from 'react';
import axios from 'axios'
import { Layout, Modal, Typography, Row, Col, Descriptions, Tabs, Button, Divider, Statistic, Form, Input, InputNumber, Space, message, Alert, Spin, Select, Table, Dropdown, Menu } from 'antd';
import MaoliangEdit from 'containers/member/maoliangEdit';
import MemberPwdEdit from 'containers/member/memberPwdEdit';
import { layout, tailLayout } from 'containers/common/layout';
import '../../form.css';

import {
    EditOutlined,
    GoldOutlined,
    EyeOutlined,
    ReloadOutlined,
    DownOutlined,
    UnorderedListOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;


const symbol:React.ReactNode = (
    <div>more</div>
)

class MemberDetail extends React.Component {

    constructor(props: any) {
        super(props);
        this.getMembers();
        this.getOrders();
    }

    state = {
        memberOrders: [],
        memberDetail: [],
        total: 0,
        loading: true,
        orderLoading: true,
        pwdEditorVisible: false,
        pwdEditorTitle: '重置密码',
        maoliangEditorVisible: false,
        maoliangEditorTitle: '赠送猫粮',
        dataId: 0,

        maoliangLoading: false,
        maoliangRecords: [],
        totalMaoliang: 0,

        shareRecordsLoading: false,
        shareRecords: [],
        shareRecordsTotal: 0,

        commentsLoading: false,
        comments: [],
        commentsTotal: 0,
    };

    orderColumns = [
        {
            title: '订单编号',
            dataIndex: 'orderId',
            width: '8%'
        },
        {
            title: '预订行程',
            dataIndex: 'tripName',
            width: '20%'
        },
        {
            title: '订单状态',
            dataIndex: 'status',
        },
        {
            title: '下单时间',
            dataIndex: 'orderTime',
        },
        {
            title: '操作',
            dataIndex: 'userId',
            render: (text: React.ReactNode) => <Link to={{ pathname: `members/detail/${text}` }} target="_blank"><Button shape="round" key={`a-${text}`}><EyeOutlined />查看</Button></Link>,
        }
    ];


    maoliangColumns = [
        {
            title: '项目',
            dataIndex: 'tripName',
        },
        {
            title: '分享对象',
            dataIndex: 'user',
            width: '20%'
        },
        {
            title: '类型',
            dataIndex: 'type',
        },
        {
            title: '猫粮',
            dataIndex: 'maoliang',
        },
        {
            title: '状态',
            dataIndex: 'status',
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
        }
    ];

    shareRecordsColumns = [
        {
            title: '项目',
            dataIndex: 'tripName',
        },
        {
            title: '查看/购买人',
            dataIndex: 'user',
        },
        {
            title: '类型',
            dataIndex: 'type',
        },
        {
            title: '猫粮',
            dataIndex: 'maoliang',
        },
        {
            title: '状态',
            dataIndex: 'status',
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
        }
    ];

    commentsColumns = [
        {
            title: '商品',
            dataIndex: 'tripName',
        },
        {
            title: '评价',
            dataIndex: 'comment',
            width: '50%',
            ellipsis: true,
        },
        {
            title: '评分',
                dataIndex: 'score',
                },
        {
        title: '更新时间',
            dataIndex: 'updateTime',
        }
    ];

getMembers = () => {
    axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/member/list', {
        params: {}
    })
        .then((res) => {
            console.log('res', res.data.data.list)
            this.setState({
                memberData: res.data.data.list,
                memberDetail: res.data.data.list[0],
                total: res.data.data.total,
                loading: false
            })
        })
        .catch((err) => {
            console.log(err)
        })
}

getOrders = () => {
    this.setState({
        orderLoading: true
    });
    axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/order/list', {
        params: {}
    })
        .then((res) => {
            console.log('res orders', res.data.data.list)
            this.setState({
                memberOrders: res.data.data.list,
                totalOrders: res.data.data.total,
                orderLoading: false
            })
        })
        .catch((err) => {
            console.log(err)
        })
}

getMaoliang = () => {
    this.setState({
        maoliangLoading: true
    });
    axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/maoliang/list', {
        params: {}
    })
        .then((res) => {
            console.log('res orders', res.data.data.list)
            this.setState({
                maoliangRecords: res.data.data.list,
                totalMaoliangRecords: res.data.data.total,
                maoliangLoading: false
            })
        })
        .catch((err) => {
            console.log(err)
        })
}

getShareRecords = () => {
    this.setState({
        shareRecordsLoading: true
    });
    axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/shareRecords/list', {
        params: {}
    })
        .then((res) => {
            this.setState({
                shareRecords: res.data.data.list,
                shareRecordsTotle: res.data.data.total,
                shareRecordsLoading: false
            })
        })
        .catch((err) => {
            console.log(err)
        })
}

getComments = () => {
    this.setState({
        commentsLoading: true
    });
    axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/comments/list', {
        params: {}
    })
        .then((res) => {
            this.setState({
                comments: res.data.data.list,
                commentsTotal: res.data.data.total,
                commentsLoading: false
            })
        })
        .catch((err) => {
            console.log(err)
        })
}

// 打开 Modal
showModal = (name: string) => {
    if (name == 'maoliangEditorVisible') {
        this.setState({
            maoliangEditorVisible: true
        })
    } else if (name == 'pwdEditorVisible') {
        this.setState({
            pwdEditorVisible: true
        })
    }
};

// 关闭 Modal
cancelModal = (name: string) => {
    if (name == 'maoliangEditorVisible') {
        this.setState({
            maoliangEditorVisible: false
        })
    } else if (name == 'pwdEditorVisible') {
        this.setState({
            pwdEditorVisible: false
        })
    }
};

// 提交表单
onFinish = (values: any) => {
    message.info("提交了表单: " + JSON.stringify(values));
    console.log('values', values);
};

// 切换Tab
onTabsClick = (value: any) => {
    if (value === 'orders') {
        console.log('tabs', value);
        this.getOrders();
    } else if (value === 'maoliang') {
        this.getMaoliang();
    } else if (value === 'shareRecords') {
        this.getShareRecords();
    } else if (value === 'comments') {
        this.getComments();
    }
}

onChange = (value: any) => {
    console.log('value', value);
    this.showModal(value.key);
}

render() {
    let detail: any = this.state.memberDetail;
    console.log('detail', detail);

    return (
        <div>
            <div className="page-title">
                <Title level={3}>会员详情</Title>
            </div>

            <Divider />

            <Spin tip="Loading..." size="large" spinning={this.state.loading}>
                <Row>
                    <Col span={18}>
                        <Descriptions title={`会员ID: ${detail.userId}`}>
                            <Descriptions.Item label="会员名">{detail.name}</Descriptions.Item>
                            <Descriptions.Item label="来源">{detail.thirdPlatformName}</Descriptions.Item>
                            <Descriptions.Item label="注册时间">{detail.registerTime}</Descriptions.Item>
                            <Descriptions.Item label="手机号">{detail.phoneNumber}</Descriptions.Item>
                            <Descriptions.Item label="QQ">{detail.qq}</Descriptions.Item>
                            <Descriptions.Item label="微信">{detail.wechat}</Descriptions.Item>
                            <Descriptions.Item label="Email">{detail.email}</Descriptions.Item>
                        </Descriptions>
                    </Col>
                    <Col span={6}>
                        <Row gutter={[18, 28]}>
                            <Col span={24}>
                                <Space>
                                    <Dropdown overlay={
                                        <Menu onClick={this.onChange}>
                                            <Menu.Item key="pwdEditorVisible"><EditOutlined />  重置密码</Menu.Item>
                                            <Menu.Item key="maoliangEditorVisible"><GoldOutlined /> 赠送猫粮</Menu.Item>
                                        </Menu>
                                    }>
                                        <Button type="primary">
                                            <UnorderedListOutlined /> 操作 <DownOutlined />
                                        </Button>
                                    </Dropdown>
                                    <Button type="default" onClick={() => { window.location.reload() }}><ReloadOutlined />刷新</Button>
                                </Space>
                                {/* <Row gutter={[10, 10]}>
                                            <Col><Button type="primary" onClick={this.showModal.bind(this, 'pwdEditorVisible')}><EditOutlined /> 重置密码</Button></Col>
                                            <Col><Button type="default" onClick={this.showModal.bind(this, 'maoliangEditorVisible')}><GoldOutlined /> 赠送猫粮</Button></Col>
                                            <Col><Button type="default" onClick={() => { window.location.reload() }}><ReloadOutlined />刷新</Button></Col>
                                        </Row> */}
                            </Col>
                            <Col span={12}>
                                <Statistic title="等级" value={detail.level} precision={0} />

                            </Col>
                            <Col span={12}>
                                <Statistic title="猫粮" value={detail.score} precision={0} />
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Spin>
            <Tabs defaultActiveKey="orders" onTabClick={this.onTabsClick}>
                <TabPane tab="订单" key="orders">
                    <Spin tip="Loading..." size="large" spinning={this.state.orderLoading}>
                        <Table
                            size="small"
                            columns={this.orderColumns}
                            dataSource={this.state.memberOrders}
                            pagination={{
                                total: this.state.total,
                                position: ["bottomLeft"],
                            }}
                        />
                    </Spin>
                </TabPane>
                <TabPane tab="猫粮" key="maoliang">
                    <Spin tip="Loading..." size="large" spinning={this.state.maoliangLoading}>
                        <Table
                            size="small"
                            columns={this.maoliangColumns}
                            dataSource={this.state.maoliangRecords}
                            pagination={{
                                total: this.state.totalMaoliang,
                                position: ["bottomLeft"],
                            }}
                        />
                    </Spin>
                </TabPane>
                <TabPane tab="分享记录" key="shareRecords">
                    <Spin tip="Loading..." size="large" spinning={this.state.shareRecordsLoading}>
                        <Table
                            size="small"
                            columns={this.shareRecordsColumns}
                            dataSource={this.state.shareRecords}
                            pagination={{
                                total: this.state.shareRecordsTotal,
                                position: ["bottomLeft"],
                            }}
                        />
                    </Spin>
                </TabPane>
                <TabPane tab="评价" key="comments">
                    <Spin tip="Loading..." size="large" spinning={this.state.commentsLoading}>
                        <Table
                            size="small"
                            columns={this.commentsColumns}
                            dataSource={this.state.comments}
                            pagination={{
                                total: this.state.commentsTotal,
                                position: ["bottomLeft"],
                                pageSize: 5

                            }}
                        />
                    </Spin>
                </TabPane>
            </Tabs>

            <MaoliangEdit dataId={this.state.dataId} editorVisible={this.state.maoliangEditorVisible} editorTitle={this.state.maoliangEditorTitle} onCancel={this.cancelModal.bind(this, 'maoliangEditorVisible')} ref="child"></MaoliangEdit>

            <MemberPwdEdit dataId={this.state.dataId} editorVisible={this.state.pwdEditorVisible} editorTitle={this.state.pwdEditorTitle} onCancel={this.cancelModal.bind(this, 'pwdEditorVisible')} ref="child"></MemberPwdEdit>
        </div>
    )
}
}

export default MemberDetail;